<template>
  <div class="book-scene" ref="box">
    <div class="book-scene__photo" :style="{ transform: fit }">
      <img
        alt=""
        class="book-scene__layer"
        decoding="async"
        :height="SCENE_SIZE.height"
        :src="`${SCENE_ASSETS}/photo.jpg`"
        :style="layer({ x: 0, y: 0, ...SCENE_SIZE })"
        :width="SCENE_SIZE.width"
      >
      <div class="book-scene__board" :style="{ transform: BOARD }">
        <div
          class="book-scene__cover"
          :class="{ 'book-scene__cover--plain': !portrait }"
        >
          <div class="book-scene__cover-group">
            <div class="book-scene__frame" v-if="portrait">
              <img
                alt=""
                class="book-scene__portrait"
                decoding="async"
                :src="portrait"
              >
            </div>
            <img
              alt=""
              class="book-scene__line"
              :src="`${SCENE_ASSETS}/long-heart.svg`"
            >
            <p class="book-scene__name">
              {{ name }}
              <span class="book-scene__years" v-if="years" v-text="years" />
            </p>
          </div>
        </div>
      </div>
      <img
        alt=""
        class="book-scene__layer book-scene__light"
        :src="`${SCENE_ASSETS}/light.webp`"
        :style="layer(SCENE_LAYERS.light)"
      >
      <img
        alt=""
        class="book-scene__layer"
        :src="`${SCENE_ASSETS}/hands.webp`"
        :style="layer(SCENE_LAYERS.hands)"
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { onBeforeUnmount, onMounted, ref } from "vue";
  import {
    boardTransform,
    coverFit,
    SCENE_ASSETS,
    SCENE_LAYERS,
    SCENE_SIZE,
  } from "../../highlights/book-scene";

  /** A cover made from the memorial page itself, before the family's book exists. */
  const props = defineProps<{
    name: string;
    portrait: string | null;
    years: string;
    /** How far in on the book: the card's crop is closer on phones. */
    zoom: number;
  }>();

  const BOARD = boardTransform();

  const box = ref<HTMLElement | null>(null);
  const fit = ref("");

  const layer = (r: {
    x: number;
    y: number;
    width: number;
    height: number;
  }) => ({
    height: `${r.height}px`,
    left: `${r.x}px`,
    top: `${r.y}px`,
    width: `${r.width}px`,
  });

  function refit() {
    const el = box.value;
    if (el?.clientWidth && el.clientHeight) {
      fit.value = coverFit(el.clientWidth, el.clientHeight, props.zoom);
    }
  }

  let observer: ResizeObserver | undefined;
  onMounted(() => {
    refit();
    if (box.value && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(refit);
      observer.observe(box.value);
    }
  });
  onBeforeUnmount(() => observer?.disconnect());
</script>
